import { zodResolver } from '@hookform/resolvers/zod';
import type { UseFormProps } from 'react-hook-form';
import {
  TabBarConfigFormSchema,
  type TabBarConfigFormValues,
} from '@/pages/onboarding/4-tab-bar-config.schema';

// Everything about how the tab bar form validates, minus its default values
// (which depend on what's already saved). Kept apart from the page so a spec
// can build the exact same form without rendering any UI.
export const TAB_BAR_FORM_OPTIONS = {
  resolver: zodResolver(TabBarConfigFormSchema),
  // Default (`mode: 'onSubmit'`) only revalidates a field on change once
  // RHF already considers it "has an error" from a prior validation run —
  // but the errors here are first set by whole-array `setValue(..., {
  // shouldValidate: true })` calls (addCustomTab/addPreset/removeTab), not
  // by a field-level touch, and that doesn't reliably arm the
  // reValidateMode shortcut for each nested `tabs.{index}.*` path. Net
  // effect: filling in a newly-added tab's title/path/icon left its red
  // warnings stuck until the next full-form submit. `onChange` validates
  // every field on every change unconditionally, independent of that
  // "already had an error" heuristic.
  mode: 'onChange',
} satisfies UseFormProps<TabBarConfigFormValues>;
